// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__0XY36","closeIcon":"modal_closeIcon__5WY1v","closeContainer":"modal_closeContainer__PuJ2p","title":"modal_title__QoY1h"};